import { pgMessage } from '../components/index'
/***
 * 节流支持异步回调
 */

export function throttleAsync(func, wait = 0) {
  let old = 0
  let pending = false
  let quest = false
  let timer = null
  const resMethod = async function (...arg) {
    const now = Date.now()
    if (now - old > wait && !pending) {
      old = now
      pending = true
      await func(...arg)
      pending = false
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(async () => {
        if (quest) {
          quest = false
          resMethod(...arg)
        }
      }, wait)
    } else {
      quest = true
    }
  }

  resMethod.cancel = function () {
    timer && clearTimeout(timer)
  }
  return resMethod
}

/***
 * 复制到剪切板
 */
export function copyMethod(str, msg = '复制成功') {
  const textarea = document.createElement('textarea')
  textarea.value = str
  document.body.appendChild(textarea)
  textarea.select()
  if (document.execCommand('copy')) {
    document.execCommand('copy')
  }
  document.body.removeChild(textarea)
  if (msg) {
    pgMessage.success(msg)
  }
}

/**
 * 根据input的file.type将文件类型转换成doc/docx/video/xls/xlsx/ppt/pptx/pdf/txt/png/jpg/jpeg/gif/bmp/mp4/mp3/wav/zip/rar/7z/zipx/rarx
 */
export function getFileType(type) {
  switch (type) {
    case 'msword':
      return 'doc'
    case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'docx'
    case 'vnd.ms-excel':
      return 'xls'
    case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'xlsx'
    case 'vnd.ms-powerpoint':
      return 'ppt'
    case 'vnd.openxmlformats-officedocument.presentationml.presentation':
      return 'pptx'
    case 'plain':
      return 'txt'
    case 'video/quicktime':
      return 'mov'
    case 'video/x-msvideo':
      return 'avi'
    case 'audio/mpeg':
      return 'mp3'
    case 'x-rar-compressed':
      return 'rar'
    case 'x-7z-compressed':
      return '7z'
    case 'x-zip-compressed':
      return 'zip'
    default:
      return type
  }
}
